import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import BotonGuardar from "../shared/botones/BotonGuardar";
import moment from "moment";
import TablaCobros from "./listadoCobros/TablaCobros";
import Buscadores from "./listadoCobros/Buscadores";
import { cobrosOps } from "../../ducks/cobros";
import { cobrosSelectores } from "../../ducks/cobros";
import { busquedasOps } from "../../ducks/busquedas";
import { colegiosOps } from "../../ducks/colegios";

class ListadoCobros extends React.Component {
  state = { idColegio: null, visible: false };

  componentDidMount() {
    this.setState({ visible: true });
    this.props.fetchSearchDataColegios();
  }

  componentWillUnmount() {
    this.props.resetListadoCobros();
    this.props.detachCobrosListeners();
    this.props.limpiarActividadSeleccionada();
    this.props.detachSearchData();
    this.props.detachSearchActividadesCobro(this.state.idColegio);
  }

  handleColegioSelect = idColegio => {
    this.setState({ idColegio });
    this.props.obtenerDetalleColegio(idColegio);
    this.props.resetSearchDataActividades();
    this.props.putVariasActividades();
    this.props.obtenerSearchDataActividadesCobro(idColegio);
    this.props.limpiarActividadSeleccionada();
  };

  handleActividadSelect = idActividad => {
    idActividad === "V.actividades"
      ? this.props.putVActividadesSeleccionada()
      : this.props.putActividadSeleccionada({
          idColegio: this.state.idColegio,
          idActividad
        });
  };

  handleSearch = data => this.props.obtenerListadoCobros(data);

  handleGuardar = () => {
    const nombreListado = prompt(
      "Si quieres, puedes añadir alguna nota sobre este listado"
    );

    this.props.guardarListado({
      listadoCobros: this.props.listadoCobros,
      detalleColegio: this.props.detalleColegio,
      nombreListado
    });
  };

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container fluid textAlign="center">
            <Segment>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />
              <BotonGuardar floated="right" action={this.handleGuardar} />
              <Header>
                Listado de Cobros -{" "}
                {this.props.detalleColegio && this.props.detalleColegio.nombre}{" "}
                - {moment().format("DD/MM/YYYY")}
              </Header>
            </Segment>
            <Segment>
              <Buscadores
                handleSearch={this.handleSearch}
                searchDataColegios={this.props.searchDataColegios}
                searchDataActividades={this.props.searchDataActividades}
                onColegioSelect={this.handleColegioSelect}
                onActividadSelect={this.handleActividadSelect}
                buttonDisabled={this.state.idColegio === null}
              />
            </Segment>
            <Segment basic>
              <TablaCobros
                datos={this.props.listadoCobros}
                action={this.props.insertaComentario}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  listadoCobros: cobrosSelectores.getCobrosActividad(state),
  searchDataColegios: state.busquedas.searchDataColegios,
  searchDataActividades: state.busquedas.searchDataActividades,
  detalleColegio: state.colegios.detalleColegio
});

const actions = {
  /*- busquedasOps -*/
  fetchSearchDataColegios: busquedasOps.fetchSearchDataColegios,
  resetSearchDataColegios: busquedasOps.resetSearchDataColegios,
  detachSearchData: busquedasOps.detachSearchData,
  resetSearchDataActividades: busquedasOps.resetSearchDataActividades,
  putVariasActividades: busquedasOps.putVariasActividades,
  obtenerSearchDataActividadesCobro:
    busquedasOps.obtenerSearchDataActividadesCobro,
  detachSearchActividadesCobro: busquedasOps.detachSearchActividadesCobro,
  /*- cobrosOps -*/
  obtenerListadoCobros: cobrosOps.obtenerListadoCobros,
  resetListadoCobros: cobrosOps.resetListadoCobros,
  detachCobrosListeners: cobrosOps.detachCobrosListeners,
  limpiarActividadSeleccionada: cobrosOps.limpiarActividadSeleccionada,
  putVActividadesSeleccionada: cobrosOps.putVActividadesSeleccionada,
  putActividadSeleccionada: cobrosOps.putActividadSeleccionada,
  insertaComentario: cobrosOps.insertaComentario,
  guardarListado: cobrosOps.guardarListado,
  /*- colegiosOps -*/
  obtenerDetalleColegio: colegiosOps.obtenerDetalleColegio
};

export default connect(mapStateToProps, actions)(ListadoCobros);



// WEBPACK FOOTER //
// ./src/pages/listados/ListadoCobros.jsx